export const RETRIEVE_MAP_REQUEST = 'RETRIEVE_MAP_REQUEST';
export const CANCEL_RETRIEVE_MAP_REQUEST = 'CANCEL_RETRIEVE_MAP_REQUEST';
export const SET_MAP_REQUEST = 'SET_MAP_REQUEST';
